import { appLogger } from '@/utils/app-logger/appLogger';
import FoundationRestApi, { BaseContext, Logger } from '@/utils/server/foundation-rest-api';

class BaseRestApi<Context extends BaseContext = BaseContext> extends FoundationRestApi<Context> {
    // Explicit Logger annotation keeps the structural (Winston-compatible) type
    // for subclasses, even though appLogger has a stricter signature at runtime.
    override logger: Logger = appLogger;
}

export default BaseRestApi;
